import classNames from 'classnames'

import type { ReactElement } from 'react'

import MediaCard from '~/components/MediaCard'
import MwMLoader from '~/components/MwMLoader'
import { useFilesDetailsQuery } from '~/queries/files'

import './styles.scss'

interface Props {
  className?: string
  mediaIds: string[]
}

const MediaCardWithCall = ({ className, mediaIds }: Props): ReactElement | null => {
  /** Queries & Mutations */

  const { data: fileDetail, isLoading: isFileDetailLoading } = useFilesDetailsQuery(mediaIds)

  /** Render */

  return fileDetail ? (
    !isFileDetailLoading ? (
      <div className={classNames('media-card-with-call-component', className)}>
        {fileDetail.map(({ download_url, id, mime_type, name }) => (
          <MediaCard downloadUrl={download_url} fileName={name} key={id} mimeType={mime_type} />
        ))}
      </div>
    ) : (
      <MwMLoader category="item" />
    )
  ) : null
}
export default MediaCardWithCall
